export default __webpack_public_path__ + "static/media/france.50b890f0.png";